<script lang="ts">
	import BaseNode from './BaseNode.svelte';
	import type { FlowNodePort } from '../helpers/flowBranchHandleStyles';
	import type { NodeData } from '../types/flow-types';

	export let id: string;
	export let data: NodeData;
	export let selected: boolean = false;
	export let validated: boolean = true;
	export let errors: string[] = [];

	$: gateType = String(data.gateType || 'or');
	$: conditionCount = Math.max(2, Number(data.conditionCount || 2));
	$: gateConfig = {
		or: { label: 'OR', description: 'Any condition is true', symbol: '\u22651' },
		and: { label: 'AND', description: 'All conditions are true', symbol: '&' },
		nor: { label: 'NOR', description: 'None are true', symbol: '\u22651\u0305' },
	}[gateType] || {
		label: 'OR',
		description: 'Any condition is true',
		symbol: '\u22651',
	};
	$: inputPorts = Array.from(
		{ length: conditionCount },
		(_, index): FlowNodePort => ({
			id: `input-${index}`,
			color: '#38bdf8',
		}),
	);
	$: outputPorts = [
		{ id: 'true', color: '#22c55e', label: 'true' },
		{ id: 'false', color: '#ef4444', label: 'false' },
	] satisfies FlowNodePort[];
</script>

<!-- Dynamic ports share BaseNode's measured AdvancedCardV2 shell. -->
<BaseNode
	{id}
	type="logicGate"
	{data}
	{selected}
	{validated}
	{errors}
	{inputPorts}
	{outputPorts}
	cardTitle={gateConfig.description}
	nodeTypeLabel={`${gateConfig.label} logic gate`}
	avatarOverride={{ icon: 'fa-solid fa-code-branch', backgroundColor: 'color-lightblue' }}
	{...$$restProps}
>
	<div class="gate-summary">
		<span class="gate-symbol">{gateConfig.symbol}</span>
		<span class="input-count">
			<i class="fa-solid fa-link"></i>
			{conditionCount} inputs
		</span>
	</div>
</BaseNode>

<style>
	.gate-summary {
		display: flex;
		align-items: center;
		justify-content: space-between;
		gap: 0.625rem;
		min-width: 14rem;
	}

	.gate-symbol {
		color: var(--color-lightblue, #38bdf8);
		font-family: monospace;
		font-size: 1.125rem;
		font-weight: 700;
	}

	.input-count {
		display: inline-flex;
		align-items: center;
		gap: 0.3rem;
		padding: 0.2rem 0.45rem;
		border: 1px solid var(--flow-chip-border);
		border-radius: 999px;
		color: var(--flow-chip-fg);
		font-size: 0.6875rem;
		white-space: nowrap;
	}
</style>
